import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-configurar-servicos',
  templateUrl: 'configurar-servicos.component.html'
})

export class ConfigurarServicosComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}